import "../../App.css";
import React from "react";
import Explor from "../explore_us";
import CONTACT_US from "../footer";
function Explore_Page() {
  return (
    <>
      <Explor />
      <CONTACT_US />
    </>
  );
}
export default Explore_Page;
